import {useRef} from "react";
import {
    AnimatedWrapTg,
} from "widgets/profile/ui/styles.ts";
import {CSSTransition} from "react-transition-group";
import {mergeRefs} from "shared/helpers";
import {useResize} from "../../../../app/lib/hooks/useResize.ts";
import {useHudOverlay} from "widgets/hud/model/overlayStore.ts";
import {useOutClick} from "../../../../app/lib/hooks/useOutClick.ts";
import {ContactContent} from "widgets/profile/ui/ui/ContactContent.tsx";



export const TgContactModal = () => {
    const isScreenMd = useResize()
    const openId = useHudOverlay((s) => s.openId);
    const close = useHudOverlay((s) => s.close);
    const isOpen = openId === "support";
    const nodeRef = useRef<HTMLDivElement | null>(null);
    const containerRef = useRef<HTMLDivElement | null>(null);

    useOutClick(containerRef, close);

    if (isScreenMd) return (
        <>
            <CSSTransition
                in={isOpen}
                timeout={{ enter: 200, exit: 150 }}
                classNames="hud-slide"
                unmountOnExit
                nodeRef={nodeRef}
            >
                <AnimatedWrapTg
                    ref={mergeRefs(containerRef, nodeRef)}
                    role="dialog"
                    aria-modal="true"
                >
                    <ContactContent/>
                </AnimatedWrapTg>
            </CSSTransition>
        </>
    );
}